import type { FaceId } from '@vlabs/api/artemy/model';
import { useParams } from 'react-router-dom';

export class IncorrectFaceIdError extends Error {
  constructor() {
    super('FaceId is missing or invalid');
    this.name = 'IncorrectFaceIdError';
  }
}

export function useFaceIdFromLocation(): FaceId {
  const { faceId } = useParams<{ faceId: FaceId }>();

  if (!faceId) {
    throw new IncorrectFaceIdError();
  }

  return faceId;
}
